<template>
  <div class="ty-content white">
    <el-form :inline="true" class="query-form" onsubmit="return false;" :model="keywordForm">
      <el-form-item label="任务名称:">
        <el-input
        v-model="task_name"
        placeholder="请输入任务名称"
        @input="onSearch"
        clearable></el-input>
      </el-form-item>

      <el-form-item>
        <el-button class="dsfdi" type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <div class="fr" >
        <el-button type="info" plain @click="handleEdit(false)">新增任务</el-button>
        <el-button type="info" plain @click="openDialog">设置默认任务</el-button>
      </div>
    </el-form>

    <el-table
    :data="tableData"
    empty-text="暂无数据"
    style="width: 100%;"
    stripe>
      <el-table-column label="任务名称" fixed width="250">
        <template slot-scope="scope">
         <span>{{scope.row.name ? scope.row.name : '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="任务数" width="150">
        <template slot-scope="scope">{{scope.row.number ? scope.row.number : '-'}}</template>
      </el-table-column>
      <el-table-column prop="start_time" label="任务开始时间" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.is_default === 1">-</span>
          <span v-else>{{ scope.row.start_time ? scope.row.start_time : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="任务结束时间" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.is_default === 1">-</span>
          <span v-else>{{ scope.row.end_time ? scope.row.end_time : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="100">
      <template slot="header">
          状态
          <el-tooltip
            class="item"
            effect="dark"
            placement="top-start"
          >
          <div slot="content">重新开启的任务需要重新分配给员工<br />任务关闭或到期将执行默认任务</div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </template>
      <template slot-scope="scope">
      <div v-if="scope.row.is_default === 1">-</div>
      <div v-if="scope.row.status === 3">不可操作</div>
        <el-switch
          v-else-if="scope.row.is_default === 1"
          style="display: none;"
          v-model="scope.row.status"
          :active-value="1"
          :inactive-value="2"
          active-color="#204A9E"
        >
        </el-switch>
      <el-switch
        v-else
        v-model="scope.row.status"
        :active-value="1"
        :inactive-value="2"
        active-color="#204A9E"
        @change="getStatus(scope.row.status,scope.row.id)">
      </el-switch>
      </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
             <el-button
              type="text"
              @click="handleEdit(scope.row)"
            >
              详情</el-button
            >
             <el-button
              v-if="scope.row.is_default !== 1"
              type="text"
              @click="handleDelete(scope.row.id)"
            >
              删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty  v-loading="loading"></el-empty>
      </template>
    </el-table>

    <div class="toolbar">
      <div></div>
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- //添加任务 -->
    <el-dialog :title="modelTitle" :show-close="false" :visible.sync="isRoleAdd" :close-on-click-modal="false" width="622px">
      <el-form
        class="dialog-form"
        :model="taskForm"
        label-width="105px"
        :rules="rules"
        ref="taskForm"
        v-if="isRoleAdd"
        @submit.native.prevent
      >
        <el-form-item label="任务名称:" class="di" prop="name">
          <el-input placeholder="请输入任务名称" v-model="taskForm.name" maxlength="15" show-word-limit></el-input>
          <template slot="prepend"></template>
        </el-form-item>
        <el-form-item label="添加备注:" class="di" prop="remarks">
          <el-input placeholder="请添加备注" v-model="taskForm.remarks" maxlength="15" show-word-limit></el-input>
          <template slot="prepend"></template>
        </el-form-item>
        <el-form-item label="任务数:" class="di" prop="number">
          <div style="display:flex;align-items: center;">
              <el-radio-group v-model="taskForm.type" style="width: 50%;padding: 12px 0;">
                <el-radio :label="1">按任务数量</el-radio>
                <el-radio :label="2">按任务比例</el-radio>
              </el-radio-group>
              <el-input
                v-if="this.taskForm.type === 1"
                type="number"
                placeholder="请输入内容"
                v-model="taskForm.number"
                style="width: 50%;"
              >
                <template slot="append">人</template>
              </el-input>
              <el-input
                v-if="this.taskForm.type === 2"
                type="number"
                placeholder="请输入概率"
                v-model="taskForm.number"
                style="width: 50%;"
              >
                <template class="append" slot="append">%</template>
              </el-input>
            </div>
            </el-form-item>
            <el-form-item label="任务时间:" class="di" prop="dataTime" style="margin-bottom: -30px;">
              <el-date-picker
                v-model="taskForm.dataTime"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%;"
              >
              </el-date-picker>
          </el-form-item>
      </el-form>
      <el-tooltip
        class="ty_item01"
        effect="dark"
        placement="top-start"
      >
        <div slot="content">按数量：设置X人，即需要主动联系客户为X人<br/>按比例：设置X%，即需要主动联系的客户为到某时间点添加客户的X%</div>
        <i class="el-icon-question"></i>
      </el-tooltip>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="close">取消</el-button>
        <el-button style="width: 72px;" type="primary" @click="addWord(taskForm)">保存</el-button>
      </div>
    </el-dialog>

    <!-- 设置默认任务 -->
    <el-dialog title="默认任务" :show-close="false" :visible.sync="isRoleTask" :close-on-click-modal="false" width="622px">
      <el-form
        class="dialog-form"
        :model="moTask"
        label-width="105px"
        :rules="rule"
        ref="moTask"
        v-if="isRoleTask"
        @submit.native.prevent
      >
        <el-form-item label="任务名称:" class="di" prop="name">
          <el-input placeholder="请输入任务名称" v-model="moTask.name" maxlength="15" disabled show-word-limit></el-input>
          <template slot="prepend"></template>
        </el-form-item>
        <el-form-item label="添加备注:" class="di">
          <el-input placeholder="请添加备注" v-model="moTask.remarks" maxlength="15" show-word-limit></el-input>
          <template slot="prepend"></template>
        </el-form-item>
        <el-form-item label="任务数:" class="di" prop="number" style="margin-bottom: -30px;">
            <div style="display:flex;align-items: center;">
              <el-radio-group v-model="moTask.type" style="width: 50%;padding: 12px 0;">
                <el-radio :label="1">按任务数量</el-radio>
                <el-radio :label="2">按任务比例</el-radio>
              </el-radio-group>
              <el-input
                v-if="this.moTask.type === 1"
                type="number"
                placeholder="请输入内容"
                v-model="moTask.number"
                style="width: 50%;"
              >
                <template v-if="this.moTask.type === 2 ? 'background: red;' : 'background: red'" slot="append">人</template>
              </el-input>
              <el-input
                type="number"
                v-if="this.moTask.type === 2"
                placeholder="请输入概率"
                v-model="moTask.number"
                style="width: 50%;"
              >
                <template class="ye" slot="append">%</template>
              </el-input>
            </div>
        </el-form-item>
      </el-form>
      <el-tooltip
          class="ty_items"
          effect="dark"
          placement="top-start"
        >
        <div slot="content">按数量：设置X人，即需要主动联系客户为X人<br/>按比例：设置X%，即需要主动联系的客户为到某时间点添加客户的X%</div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="isRoleTask = false">取消</el-button>
        <el-button style="width: 72px;" type="primary" @click="taskEdit(moTask)">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="温馨提示"
      :visible.sync="isible"
      :show-close="true"
      width="20%">

      <div style="margin-left: 20px;margin-bottom: 20px;">保存后，需要到任务列表点击开启</div>
      <div class="ewqoij">
        <img class="img" src="../../../assets/images/prompt.png" width=".875rem" height=".875rem">
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      task_name: '',
      isRoleAdd: false,
      keywordForm: {
        task_name: ''
      },
      pickerOptions: {
          disabledDate (time) {
            return time.getTime() < Date.now()
          }
      },
      permissionList: [],
      tableData: [],
      loading: false,
      isRoleTask: false,
      total: 0,
      modelTitle: '',
      isible: false,
      task_id: '',
      taskForm: {
        task_id: '',
        name: '',
        remarks: '',
        type: 1,
        number: '',
        dataTime: '',
        is_default: 2
      },
      moTask: {
        task_id: '',
        name: '',
        remarks: '',
        type: 1,
        number: '',
        is_default: 2
      },
      rules: {
          name: [{ required: true, message: '请输入任务名称！', trigger: 'blur' }],
          number: [{ required: true, message: '请选任务数', trigger: 'blur' }, { pattern: /^[1-9|^\\.]/, message: '任务数不能为0和负数' }],
          dataTime: [{ required: true, message: '请选择任务时间', trigger: 'blur' }]
      },
      rule: {
          name: [{ required: true, message: '请输入任务名称！', trigger: 'blur' }],
          number: [{ required: true, message: '请选任务数', trigger: 'blur' }, { pattern: /^[1-9|^\\.]/, message: '任务数不能为0和负数' }],
          dataTime: [{ required: true, message: '请选择任务时间', trigger: 'blur' }]
      },
      edit_id: ''
    }
  },
  mounted() {
    this.loading = true
    this.getList()
  },
  methods: {
    getList() {
      //  this.loading = true
      const params = {
        name: this.task_name,
        page: this.currentPage
      }
      this.$api.get('/api/system/task/index', params).then((res) => {
        res.data.forEach(item => {
          this.status = item.status
        })
        this.total = res.total
        this.tableData = res.data
        this.loading = false
      })
    },
    getStatus(status, id) {
      const params = {
          status: status,
          task_id: id
      }
      this.$api.post('/api/system/task/bind', params).then((res) => {
        if (res.status === '1') {
          this.$message.success('开启成功！')
        } else {
          this.$message.success('关闭成功！')
        }
        this.getList()
      })
    },
    handleEdit(row) {
      this.edit_id = row.id
      if (row) {
        this.modelTitle = '编辑任务'
        this.task_id = row.id
        this.taskForm = {
          task_id: row.id,
          name: row.name,
          remarks: row.remarks,
          type: row.type,
          number: row.number,
          is_default: row.is_default,
          dataTime: [row.start_time, row.end_time]
        }
      } else {
        this.modelTitle = '新建任务'
      }
      this.isRoleAdd = true
    },
    addWord(taskForm) {
      this.$refs.taskForm.validate((valid) => {
        if (valid) {
          const params = {
            name: this.taskForm.name,
            remarks: this.taskForm.remarks,
            type: this.taskForm.type,
            number: this.taskForm.number,
            start_time: this.$moment(this.taskForm.dataTime[0]).format('YYYY-MM-DD'),
            end_time: this.$moment(this.taskForm.dataTime[1]).format('YYYY-MM-DD'),
            is_default: this.taskForm.is_default
          }
          this.taskForm.task_id && (params.task_id = this.taskForm.task_id)
          if (this.task_id) {
            this.$api.post('api/system/task/edit', params).then(() => {
              this.isRoleAdd = false
              if (this.edit_id !== 1) {
                this.$message.success('保存后，需要到任务列表开启')
              }
              this.taskForm = {
                task_id: '',
                name: '',
                remarks: '',
                type: 1,
                number: '',
                dataTime: '',
                is_default: 2
              }
              this.task_id = ''
              this.edit_id = ''
              this.getList()
            })
          } else {
            this.$api.post('/api/system/task/add', params).then(() => {
              this.isRoleAdd = false
              this.taskForm = {
                task_id: '',
                name: '',
                remarks: '',
                type: 1,
                number: '',
                dataTime: '',
                is_default: 2
              }
              this.isible = true
              this.task_id = ''
              this.getList()
            })
          }
        }
      })
    },
    rowClassName(record, index) {
      if (record.row.status === 3) {
          return 'rowClassName'
      }
    },
    close() {
      this.isRoleAdd = false
      this.task_id = ''
      this.taskForm.type = 1
      this.taskForm.task_id = ''
      this.taskForm.name = ''
      this.taskForm.remarks = ''
      this.taskForm.number = ''
      this.taskForm.dataTime = ''
    },
    handleDelete(id) {
      this.$confirm('删除后，设置该任务的员工将执行默认任务，是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          this.$api
            .post('/api/system/task/delete', {
              task_id: id
            })
            .then(() => {
              this.getList()
            })
        })
    },
    onSearch() {
      this.currentPage = 1
      this.getList()
    },
    defaultTask() {
      this.$api.get('/api/system/task/default/task').then((res) => {
        this.moTask.task_id = res.id
        this.moTask.name = res.name
        this.moTask.remarks = res.remarks
        this.moTask.type = res.type
        this.moTask.number = res.number
      })
    },
    checkNum(event) {
      if (event.key === '-') {

      }
    },
    taskEdit(moTask) {
      this.$refs.moTask.validate((valid) => {
        if (valid) {
          const params = {
            task_id: this.moTask.task_id,
            name: this.moTask.name,
            remarks: this.moTask.remarks,
            type: this.moTask.type,
            number: this.moTask.number,
            is_default: this.moTask.is_default
          }
          this.$api.post('api/system/task/edit', params).then((res) => {
            this.isRoleTask = false
            this.getList()
          })
        }
      })
    },
    addDialog() {
      this.taskFrom = {}
      this.fisRoleAdd = true
    },
    openDialog() {
      this.isRoleTask = true
      this.defaultTask()
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
    },
    yan() {
      if (this.radio === 2) {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.di {
  margin-bottom: 0;
  text-align: left;
  margin-left: auto;

}
 .xiao {
      border-right: 35px solid #204A9E;
  }
>>> .el-form-item__content{
  margin-left: 0;
}
.ty_item01{
  position: relative;
  bottom: 76px;
  left: -93px;
}
// @media screen and (min-width:960px) and (max-width:1366px){
//     .ty_item01{
//       position: relative;
//       bottom: 107px;
//       left: 1%;
//     }
// }
.ty_items{
  position: relative;
  top: -15px;
  left: -93px;
}
::v-deep .el-dialog .el-dialog__title {
    font-size: 18px;
    color: #204a9e;
    font-weight: 500;
}
.el-input-group__append {
  background: #204A9E;
  color: white;
}
.uhui{
    width: 450%;
    z-index: 999;
    height: 39px;
    line-height: 38px;
    background: rgb(32, 74, 158);
    color: rgb(255, 255, 255);
    position: relative;
    left: -20px;
}
// ::v-deep .el-dialog__close{
//     display: none;
// }
::v-deep .el-form--inline .el-form-item {
    margin-bottom: 0px;
}
v-deep .ty-main .ty-content.white{
  padding: 24px 20px
}
// .el-icon-question:before{
//   position: absolute;
//   left: -113px;
// }
.el-date-table td.in-range span:hover{
  color: #fff;
  background: #234C9C;
}
.el-date-table td span:hover{
  color: #234C9C;
}
.el-date-table td span:focus{
  color: #234C9C;
}
.ewqoij{
  position: absolute;
  top: 84px;
  width: .875rem;
  height: .875rem;
  .img {
    width: .875rem;
    height: .875rem;
  }
}
::v-deep .el-dialog__body {
  padding-top: 30px;
  padding-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;
}
::v-deep .el-dialog .el-dialog__body .el-radio{
  width: 50%;
  margin-right: 0;
}
::v-deep .el-form-item__error{
  position: absolute;
  top: auto;
}
</style>
